<template>
  <div @click="clickCard" class="mt-4 card-product">
    <div class="card-content" :class="{'card-content-full': !showImage}">
      <p class="text-subtitle-2 mb-2 primary--text font-weight-medium text-truncate"> {{ product.name }}</p>

      <div class="card-description">
        <p class="text-description font-weight-normal mb-0">{{product.description}}</p>
      </div>

      <div class="card-price">
        <p class="font-weight-bold primary--text ma-0">{{ productPrice(product) }}</p>
      </div>
    </div>
    <v-img
        v-if="showImage"
        height="120"
        width="120"
        class="card-image rounded-lg"
        :src="product.image"
    />
  </div>
</template>

<script>
export default {
  name: "CardProduct",
  props: {
    product: {
      required: true,
      type: Object
    },
    showImage: {
      required: true
    }
  },
  methods: {
    clickCard () {
      this.$emit('clicked')
    }
  }
}
</script>

<style lang="scss">
.card-product {
  position: relative;
  height: 120px;
  border-radius: 10px;
  box-shadow: 0 8px 6px -6px #cecece;

  .btn-add-cart {
    position: absolute;
    right: -10px;
    z-index: 1;
    top: -10px;
  }

  .card-content-full {
    width: 100% !important;
  }

  .card-content {
    width: 210px;
    padding-left: 10px;

    .card-price {
      position: absolute;
      bottom: 0;

      .price-signal {
        font-size: 13px;
      }
    }

    .card-description {
      width: 100%;

      .text-description {
        font-size: 13px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }

  .card-image {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>